import { render, staticRenderFns } from "./SearchAvailabilities.vue?vue&type=template&id=d66975a8"
import script from "./SearchAvailabilities.vue?vue&type=script&lang=ts"
export * from "./SearchAvailabilities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports